import { useState } from "react";
import { getMyRegistrations } from "../../../../network/Apiservices";
import { deviceType } from "../../utils/types";

interface StateType {
  registrations: deviceType[];
}
const defaultState: StateType = {
  registrations: [],
};
export const Handler = (props: any) => {
  const { registrations } = props;
  const [state, setState] = useState(defaultState);

  const getMyRegistrationsApiHandler = async () => {
    try {
      let response = await getMyRegistrations();
      if (response) {
        setState((ps) => ({ ...ps, registrations: response.registrations }));
      } else {
        throw new Error("Error fetching registrations");
      }
    } catch (error: any) {
      throw error;
    }
  };
  return { registrations, getMyRegistrationsApiHandler, state };
};
